type ShopifyMetafieldLike =
  | { namespace?: string | null; key?: string | null; value?: string | null }
  | null
  | undefined;

export function getVariantPickerColorMetafieldIdentifiers(
  fullKey: string | undefined,
): { namespace: string; key: string }[] | undefined {
  const parsedKey = fullKey ? parseShopifyMetafieldKey(fullKey) : null;
  return parsedKey ? [parsedKey] : undefined;
}

export function getVariantPickerColorMetafields(
  metafields: ShopifyMetafieldLike[] | null | undefined,
  fullKey: string | undefined,
): Record<string, string | null> | undefined {
  if (!fullKey) {
    return undefined;
  }

  const value = getShopifyMetafieldValue(metafields, fullKey);
  if (value === undefined) {
    return undefined;
  }

  return { [fullKey]: value ?? null };
}

function parseShopifyMetafieldKey(
  fullKey: string,
): { namespace: string; key: string } | null {
  const trimmedValue = fullKey.trim();
  if (!trimmedValue) {
    return null;
  }

  const [namespace, key, ...rest] = trimmedValue.split(".");
  if (!namespace || !key || rest.length > 0) {
    return null;
  }

  return { namespace, key };
}

function getShopifyMetafieldValue(
  metafields: ShopifyMetafieldLike[] | null | undefined,
  fullKey: string | undefined,
): string | null | undefined {
  if (!fullKey || !metafields?.length) {
    return undefined;
  }

  const parsedKey = parseShopifyMetafieldKey(fullKey);
  if (!parsedKey) {
    return undefined;
  }

  const metafield = metafields.find(
    (item) =>
      item?.namespace === parsedKey.namespace && item.key === parsedKey.key,
  );

  return metafield?.value;
}
